<!--
 * @Author: ShiWeiShan
 * @Date: 2020-12-04 14:32:16
 * @LastEditTime: 2020-12-23 11:08:02
 * @LastEditors: ShiWeiShan
 * @Description: 上传申报文件
 * @FilePath: \fs-js-pcweb-user\src\components\adjustFlowChart\uploadApplyFile.vue
-->
<template>
  <div class="upload-apply-file">
    <div class="upload-form">
      <label for="file-upload" class="form-label">上传文件：</label>
      <common-upload id="file-upload" v-model="files" fileAccept="image/jpeg,application/pdf"></common-upload>
    </div>
    <div class="dialog-footer">
      <el-button size="mini" type="success" style="margin-right: 5px;" @click="$submit">提交</el-button>
      <el-button size="mini" @click="$cancle">取消</el-button>
    </div>
    <hd-loading v-if="pageLoading"></hd-loading>
  </div>
</template>

<script>
import commonUpload from '@/components/public/commonUpload.vue'
import {
  A_WPAL_UploadApplyFile
} from '@/assets/js/axiosPresets'
export default {
  components: {
    commonUpload
  },
  props: {
    recordId: Number
  },
  data () {
    return {
      files: [],
      pageLoading: false
    }
  },
  methods: {
    async $submit () {
      console.log(12465, this.recordId)
      if (this.files.length === 0) {
        this.$message.warning('请上传文件!')
        return
      }
      const newFormData = new FormData()
      if (this.files != null) {
        this.files.forEach(item => {
          newFormData.append('file_upload', item)
        })
      }
      newFormData.append('obj_id', this.recordId)
      console.log(newFormData)
      await this.$confirm('确认保存？')
      this.pageLoading = true
      const res = await this.$F_checkAxiosIn(A_WPAL_UploadApplyFile(newFormData))
      this.pageLoading = false
      if (!res) { return }
      this.$emit('successThen')
    },
    $cancle () {
      this.$emit('cancle')
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-apply-file {
  padding: 6px;
  .upload-form {
    display: flex;
    .form-label {
      padding-top: 4px;
      font-size: 14px;
      line-height: 20px;
      text-align: right;
      margin-right: 4px;
    }
  }
  .dialog-footer {
    margin-top: 25px;
    text-align: right;
  }
}
</style>